import useCancellablePromises from './useCancellablePromises';

export const cancellablePromise = (promise) => {
  let isCanceled = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(
      // eslint-disable-next-line prefer-promise-reject-errors
      (value) => (isCanceled ? reject({isCanceled, value}) : resolve(value)),
      // eslint-disable-next-line prefer-promise-reject-errors
      (error) => reject({isCanceled, error})
    );
  });

  return {
    promise: wrappedPromise,
    cancel: () => (isCanceled = true),
  };
};

export const noop = () => {};

export const delay = (n) => new Promise((resolve) => setTimeout(resolve, n));

const useClickPreventionOnDoubleClick = (onClick, onDoubleClick) => {
  const api = useCancellablePromises();

  const handleClick = (e, data) => {
    api.clearPendingPromises();
    const waitForClick = cancellablePromise(delay(300));
    api.appendPendingPromise(waitForClick);

    return waitForClick.promise
      .then(() => {
        api.removePendingPromise(waitForClick);
        onClick(e, data);
      })
      .catch((errorInfo) => {
        api.removePendingPromise(waitForClick);
        if (!errorInfo.isCanceled) {
          throw errorInfo.error;
        }
      });
  };

  const handleDoubleClick = (e, data) => {
    api.clearPendingPromises();
    onDoubleClick(e, data);
  };

  return [handleClick, handleDoubleClick];
};

export default useClickPreventionOnDoubleClick;
